import JSCookie from 'js-cookie';

export default class LoginStateManager {
    public static isLoggedIn = () => {
        const cookie = JSCookie.get('reporter');
        return cookie !== null && cookie !== undefined && cookie !== '' && cookie && cookie.length && cookie !== 'null';
    };
    public static logout = async () => {
        JSCookie.remove('reporter');
        JSCookie.remove('reporter', { domain: 'clento.ai' });
        JSCookie.remove('reporter', { domain: '.clento.ai' });
        window.location.href = '/login';
    };
}
